"use client"

import { useProductsByEans } from "@/hook/use-products-by-eans"
import { t } from "@/languages/i18n"
import { FC } from "react"
import { ProductItemCard } from "../product/ProductItemCard"

export interface RecommendProductProps {
  eans?: string[]
}

export const RecommendProduct: FC<RecommendProductProps> = ({ eans }) => {
  const { products, loading, error } = useProductsByEans(eans)

  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#18AF4E]"></div>
      </div>
    )
  }

  if (error || !products || products.length === 0) {
    return null
  }

  const data = products
    ?.filter(e => !!e)
    .map(e => ({
      title: e?.name,
      url: e?.image.lg ?? "https://res.cloudinary.com/dft7ad2xf/image/upload/v1683213912/i05hkkqzu5mxvojafzx0.png",
      sale: e?.discountPercentage,
      salePrice: e?.bundlePrice,
      price: e?.originPrice,
      category: `${t("In stock")} > ${e?.inStockCount}`,
      weight: "12ks/krt",
      type: e?.isLetak ? "Letak" : "",
      isFavorited: true,
      productUrl: e?.url,
      discountPercentage: e?.discountPercentage,
    }))

  return (
    <div className="w-full">
      <div className="flex flex-col">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {data.map((item, key: number) => (
            <ProductItemCard
              key={key}
              title={item.title}
              url={item.url}
              salePrice={item.salePrice}
              price={item.price}
              category={item.category}
              weight={item.weight}
              productUrl={item.productUrl}
              discountPercentage={item.discountPercentage}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
